import React from 'react'
import type { ComponentProps } from 'react'

import type { Upload } from '@fourthwall/components'
import { Button, Icon, UploadAreaUI } from '@fourthwall/components'
import { ExpandAltIcon, PhotoIcon, UploadIcon } from '@fourthwall/icons'

import * as S from './ThankYouCardUploaderEmpty.styled'
import thankYouCardsImage from './assets/thank-you-cards-image.webp'

export const ThankYouCardUploaderEmpty = (
  props: ComponentProps<NonNullable<ComponentProps<typeof Upload>['content']>>,
) => (
  <UploadAreaUI.ContentWrapper disabled={false} invalid={false} size="large" {...props}>
    <UploadAreaUI.Hero size="large" orientation="vertical">
      <S.Container>
        <S.Image src={thankYouCardsImage} alt="Example of custom inserts" />
        <Button
          leftIcon={<Icon component={UploadIcon} height={16} />}
          label="Upload image"
          appearance="primary"
          size="small"
        />
        <S.Content>
          <S.Description>
            <Icon component={ExpandAltIcon} height={16} />
            <p>
              6 x 4 inches (15.24 x 10.16 cm)
              <br />
              1800 x 1200 px (300 DPI)
            </p>
          </S.Description>
          <S.Description>
            <Icon component={PhotoIcon} height={16} />
            <p>
              PNG, JPG supported
              <br />
              Max 25 MB
            </p>
          </S.Description>
        </S.Content>
      </S.Container>
    </UploadAreaUI.Hero>
  </UploadAreaUI.ContentWrapper>
)
